
// Main Variables
var cartCheck = document.querySelector(".template-cart") !== null,
    addToCartForms = document.querySelectorAll(".add-to-cart-form");

let addToCartFormSelector = ".add-to-cart-form",
    addToCartForm = document.querySelector(".add-to-cart-form"),
    productOptionSelector = ".add-to-cart-form [name*=option]",
    productOptions = document.querySelectorAll(addToCartFormSelector + " [name*=option]"),
    optionCheck = document.querySelector(productOptionSelector) !== null,
    removeLinks = document.querySelectorAll(".mini-cart-contents .js-remove-line");

let productForm = {
  onProductOptionChanged: function (event) {

    // Description:
    // This function is called when a product option is changed. It updates the product variant and validates the form.

    let form = event.target.closest(addToCartFormSelector),
        selectedVariant = productForm.getActiveVariant(form),
        lineItems = document.querySelectorAll(".line-item")

        // console.log("form changed on #" + form.getAttribute("id"));

        productForm.validate(event, selectedVariant);

        lineItem.qtyCartCheck();
        // lineItems.forEach((item) => {
        //   qtyInCart(item);
        // });
  },
  getActiveVariant: function (form) {


    // Description:
    // This function gets the currently selected variant from the current Add to Cart form.


    let variantsData = form.dataset.variants,
        decodeVariants = decodeURIComponent(variantsData),
        variants = JSON.parse(decodeVariants),
        formData = serializeArray(form),
        formOptions = {
          option1: null,
          option2: null,
          option3: null,
        },
        selectedVariant = null;

    // 1. Decode the form data

    formData.forEach((item) => {
      if (item.name.indexOf("option") !== -1) {
        formOptions[item.name] = item.value;
      }
    });

    // 2. Extract the selected options - look over the form data and find the selected options

    // 3. Match these options to the variants in the product data, matching the selectedVariant

    variants.forEach((variant) => {
      if (variant.option1.indexOf('"') !== -1) {
        variant.option1 = variant.option1.replace(/"/g, "");
      }

      if (variant.option1 === formOptions.option1) {
        if (variant.option2 === formOptions.option2) {
          if (variant.option3 === formOptions.option3) {
            selectedVariant = variant;
            return false;
          }
        }
      }
    });

    // 3. Return the selected variant
    return selectedVariant;

    // // console.log("selected variant = " + selectedVariant.title);
    // // console.log('selected variant = ' + selectedVariant)
    // // console.log('form data', formData)
    // // console.log('form options', formOptions)
  },
  validate: function (event, selectedVariant) {
    // // // console.log("form validate function");
    // // console.log(selectedVariant);
    // // console.log(selectedVariant.inventory_quantity);
    // // console.log(selectedVariant.inventory_management);

    // Description:
    // This function validates the selected variant and updates the form to reflect the variant's availability.
    // Optional additional functions 

    let form = event.target.closest(addToCartFormSelector),
        hasVariant = selectedVariant !== null,
        canAddToCart = hasVariant && selectedVariant.available,
        addToCartButton = form.querySelector(".add-to-cart-button"),
        productPricesDoc = document.querySelectorAll(".js-price"),
        comparePricesDoc = document.querySelectorAll(".js-compare-at-price"),
        quickAddPrice = form.querySelector(".add-to-cart-button--popover .js-quick-price"),
        priceHtml = null,
        compareHtml = null,
        quantityPicker = form.querySelector("quantity-input"),
        pickerInput = quantityPicker.querySelector("input"),
        fields = document.querySelectorAll(".line-item-property__field"),
        isQuickPopover = form.classList.contains("quick-add--popover"),
        currentCurrency = document.querySelector('html').dataset.currency,
        price = form.querySelector(".js-price"),
        prices = form.querySelectorAll(".js-price"),
        comparePrice = form.querySelector(".js-compare-at-price"),
        comparePrices = form.querySelectorAll(".js-compare-at-price")

    // console.log(selectedVariant);
    
    if (hasVariant) {
      // Establish correct pricing and currency
      // console.log("current currency = " + currentCurrency);
      // console.log("selected variant price = " + selectedVariant.price);
      // Get the price and compare price, format and return valriables
      let formattedVariantPrice = currentCurrency + (selectedVariant.price / 100).toFixed(0);

          priceHtml = formattedVariantPrice
          compareHtml = ""

        if (selectedVariant.compare_at_price) {
          // If there is a compare at price, format it and display it
          let formattedComparePrice = currentCurrency + (selectedVariant.compare_at_price / 100).toFixed(0);
              compareHtml = formattedComparePrice;

              document.querySelector(".product-main__info__row--title .price").classList.add("price--on-sale");

        } else {
          document.querySelector(".product-main__info__row--title .price").classList.remove("price--on-sale");
          // If there is no compare at price, display the default price
          compareHtml = comparePrice.dataset.defaultPrice;
        }


      // Update form data
      updateInputs(selectedVariant, form, pickerInput);
      
      // Update product media
      updateProductMedia(selectedVariant);
      // Change URL to reflect selected variant
      updateURL(selectedVariant);

    } else {
      priceHtml = price.dataset.defaultPrice;
      formattedComparePrice = null;
    }

    // Update the visible product prices
    productPricesDoc.forEach((price) => {
      price.innerHTML = priceHtml;
    });

    comparePricesDoc.forEach((price) => {
      price.innerHTML = compareHtml;
    });

    if (canAddToCart) {
      // // console.log("can add to cart");
      html.classList.remove("unavailable");
      addToCartButton.removeAttribute("disabled");
      addToCartButton.classList.remove("disabled--button");
    } else {
      // // console.log("cannot add to cart");
      html.classList.add("unavailable");
      addToCartButton.setAttribute("disabled", "");
      addToCartButton.classList.add("disabled--button");
    }

  },
  init: function () {
    addToCartForms.forEach((form) => {
      form.addEventListener("change", function (event) {
        productForm.onProductOptionChanged(event);
      });
    });
  },
};



class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.input = this.querySelector("input");
    this.button = this.querySelectorAll("button").forEach((button) => {
      button.addEventListener("click", this.onButtonClick.bind(this));
    });
  }

  onButtonClick(event) {
    event.preventDefault();

    const previousValue = parseInt(this.value);

    let max = parseInt(this.input.getAttribute("max"));
    let min = parseInt(this.input.getAttribute("min"));
    let minusButton = this.querySelector("button[name=minus]");
    let plusButton = this.querySelector("button[name=plus]");
    let thisName = event.target.closest("button").getAttribute("name");

    if (thisName === "plus") {
      // // console.log("current value = " + this.input.value);
      this.input.stepUp();
      // // console.log("step up value = " + this.input.value);

      if (this.input.value == max) {
        plusButton.setAttribute("disabled", "");
        plusButton.setAttribute("aria-disabled", "true");
      } else {
        plusButton.removeAttribute("disabled");
        plusButton.removeAttribute("aria-disabled");
      }

      if (this.input.value > min) {
        minusButton.removeAttribute("disabled", "");
        minusButton.removeAttribute("aria-disabled", "true");
      } else {
        minusButton.setAttribute("disabled", "");
        minusButton.setAttribute("aria-disabled", "true");
      }
    } else if (thisName === "minus") {
      // // console.log("current value = " + this.input.value);
      this.input.stepDown();
      // // console.log("step down value = " + this.input.value);

      if (this.input.value == 1) {
        minusButton.setAttribute("disabled", "");
        minusButton.setAttribute("aria-disabled", "true");
      }
    }

    if (previousValue != this.input.value) {
      this.input.dispatchEvent(new Event("change"));
      this.input.setAttribute("value", this.input.value);
    }
  }
}


//  Ajax API Cart
let ajaxify = {
  onAddToCart: function (event) {
    // console.log("ajax add to cart");
    event.preventDefault();

    let addToCartForm = event.target.closest(".add-to-cart-form"),
        formData = new FormData(addToCartForm),
        dataValues = Object.fromEntries(formData.entries()),
        cartIndicator = document.querySelectorAll(".js-cart-status"),
        addToCartButton = addToCartForm.querySelector(".add-to-cart-button");

    // Fetch API to add item to cart

    fetch(window.Shopify.routes.root + "cart/add.js", {
      method: "POST",
      body: formData,
    })
      .then((response) => {
        return (
          response.json(), ajaxify.onCartUpdated()
        );
      })
      .catch((error) => {
        console.error("Error:", error), ajaxify.onError;
      });

    // Add class to any cart icons to show items in cart

    cartIndicator.forEach((count) => {
      count.classList.add("item--add");
      count.classList.add("has-items");
      count.classList.remove("empty");
    });

    // Check if quick add to cart button, add confirmation message if not.
    if (addToCartButton.classList.contains("quick-add-to-cart-button")) {
      cartConfirmation(addToCartButton);
    } else {
      // toggleMiniCart();
      cartConfirmation(addToCartButton);
    }

  },
  onCartUpdated: function (remove) {
    //  // console.log('update cart')

    // Update cart contents by fetching the cart page data
    fetch("/cart")
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        // // console.log(html)
        let parser = new DOMParser(),
          htmlCart = parser.parseFromString(html, "text/html"),
          dataCartContents = htmlCart.querySelector(".main-cart-contents"),
          dataCartItemCount = dataCartContents.dataset.cartItemCount,
          miniCartContents = document.querySelector(".js-mini-cart-contents"),
          cartPageContents = document.querySelector(".main-cart-contents"),
          contents = document.querySelector(".cart-contents"),
          cartItemCounts = document.querySelectorAll(".js-cart-count"),
          cartItemTotals = document.querySelectorAll(".js-cart-total"),
          cartTotal = document.querySelector(".js-cart-total"),
          dataCartTotal = dataCartContents.dataset.cartTotal,
          cartIcons = document.querySelectorAll(".js-cart-icon"),
          cartLineItems = document.querySelectorAll(".line-item"),
          dataLineItems = dataCartContents.querySelectorAll(".line-item"),
          lineQuantities = document.querySelectorAll(".js-line-quantity");

        // Update classes of cart icons based on cart contents
        if (dataCartItemCount > 0) {
          // // console.log("cart has items");
          cartIcons.forEach((icon) => {
            icon.classList.add("has-items");
          });
        } else {
          // // console.log("cart is empty");
          cartIcons.forEach((icon) => {
            icon.classList.remove("has-items");
          });
        }

        // Update cart item counts
        updateCartItemCounts(dataCartItemCount, dataCartContents)

        // If update is done in Mini Cart, clear the mini cart contents, replace with the new cart contents. If not, update the cart page contents.
        updateCartContents(dataCartContents, miniCartContents, cartPageContents, contents);

        // If item has changed on data cart, update mini cart item
        updateMiniCartLine(cartLineItems, dataLineItems);
       
        // Update cart item counts and totals
        updateRemoveLines(remove)

        // If removing an item, check if cart is empty, if so, remove all contents, if not, update contents
        updateCartItems(remove, dataCartItemCount, dataCartContents, miniCartContents, cartPageContents, contents);

        lineQuantities.forEach((qty) => {
          qty.addEventListener(
            "change",
            lineItem.onLineQtyChanged,
            lineItem.updatePickerButton(qty),
            lineItem.updatePDPButton(qty, false)
          );
        });
        lineItem.qtyCartCheck();
      })
      .catch((error) => {
        console.error("Error:", error), ajaxify.onError;
      });
  },
  updateMaxQuantity: function (event, quantity) {
    if (cartCheck) {
      return;
    } else if (productCheck) {
      // Updates max quantity on product page when using Ajax add to cart

      let addToCartForm = document.querySelector(".add-to-cart-form:not(.quick-add-to-cart-form)"),
          addToCartButton = addToCartForm.querySelector(".add-to-cart-button"),
          quantityInput = addToCartForm.querySelector("quantity-input input[name=quantity]"),
          variantManagement = addToCartForm.querySelector(".js-variant-management"),
          selectedVariantQty = document.querySelector(".js-variant-qty").value,
          maxQuantity = quantityInput.getAttribute("max"),
          newQuantity = maxQuantity - quantity;

      if (variantManagement.value != null) {
        // // console.log("update max quantity to " + newQuantity);
        quantityInput.setAttribute("max", newQuantity);
        selectedVariantQty = newQuantity;
      } else {
        // // console.log("update max quantity to " + 100);
        quantityInput.setAttribute("max", 100);
        selectedVariantQty = 100;
      }

      if (newQuantity <= 0) {
        // // console.log("quantity is 0, stop cart ajax button");
        addToCartButton.setAttribute("disabled", "");
        addToCartButton.classList.add("disabled--button");
      } else {
        // // console.log("quantity is not 0, enable cart ajax button");
        addToCartButton.removeAttribute("disabled");
        addToCartButton.classList.remove("disabled--button");
      }
    }
  },
  onError: function (XMLHttpRequest, textStatus) {
    let data = XMLHttpRequest.responseJSON;
    alert(data.status + " – " + data.message + " : " + data.description);
  },
  init: function () {
    document.querySelectorAll("form.add-to-cart-form").forEach((form) => {
      form.addEventListener("submit", ajaxify.onAddToCart);
    });
    // document.querySelectorAll(".line-item").forEach((item) => {
    //   qtyInCart(item);
    // });
    document.querySelectorAll("quantity-input.location__line-item").forEach((picker) => {
        picker.addEventListener("change", function () {
          lineItem.updatePickerButton(picker);
          ajaxify.onAddToCart();
        });
      });
  },
};

ajaxify.init();




// Line Item
let removeLineSelector = ".js-remove-line",
    lineQuantitySelector = ".js-line-quantity",
    lineItem = {
      isInMiniCart: function (element) {
      
      let miniCartContents = element ? element.closest(".js-mini-cart-contents") : null
      if (miniCartContents) {
        // console.log("in mini cart");
        let isInMiniCart = miniCartContents.length !== 0;
        return isInMiniCart;
      } else {
        // console.log("not in mini cart");
      }
  },
  onLineQtyChanged: function () {
    // // console.log("change line qty ");

    let quantity = this.value,
      id = this.getAttribute("id").replace("updates_", ""),
      changes = {
        quantity: quantity,
        id: id,
      },
      JSONchanges = JSON.stringify(changes);

    if (lineItem.isInMiniCart(this)) {
      // // console.log("in mini cart");
      fetch(window.Shopify.routes.root + "cart/change.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSONchanges,
      })
        .then((response) => {
          return (
            response.text(), ajaxify.onCartUpdated(),
             console.log("update cart")
          );
        })
        .catch((error) => {
          console.error("Error:", error), ajaxify.onError;
        });
    } else {
      // // console.log("in cart");

      fetch(window.Shopify.routes.root + "cart/change.js", {
        method: "POST",
        credentials: "same-origin",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSONchanges,
      })
        .then((response) => {
          return (
            response.text(),
            ajaxify.onCartUpdated(),
            console.log("update cart page")
          );
        })
        .catch((error) => {
          console.error("Error:", error), ajaxify.onError;
        });
    }
  },
  onLineRemoved: function (event) {
    // console.log("click remove");

    event.preventDefault();

    let removeKey = this.dataset.id,
      items = {
        quantity: 0,
        id: removeKey,
      },
      JSONitems = JSON.stringify(items),
      remove = true;

    // // console.log(items);
    // // console.log(JSONitems);

    fetch(window.Shopify.routes.root + "cart/change.js", {
      method: "POST",
      credentials: "same-origin",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSONitems,
    })
      .then((response) => {
        return response.text(), ajaxify.onCartUpdated(true),
        cartScripts();
      })
      .catch((error) => {
        console.error("Error:", error), ajaxify.onError;
      });
  },
  updatePickerButton: function (item) {
    let pickerMax = item.getAttribute("max");

    if (item.value == pickerMax) {
      item
        .closest("quantity-input")
        .querySelector("button[name=plus]")
        .setAttribute("disabled", "");
    } else {
      item
        .closest("quantity-input")
        .querySelector("button[name=plus]")
        .removeAttribute("disabled");
    }
  },
  updatePDPButton: function (item) {
    if (cartCheck) {
      // // console.log('cart check')
      return;
    } else {
      let thisLineId = item.dataset.id,
        thisSelected = document.querySelector(".js-variant-id").value;
      if (thisLineId == thisSelected) {
        let thisMax = item.getAttribute("max"),
          addToCartButton = document.querySelector(".add-to-cart-button");

        if (item.value == thisMax) {
          // // console.log('max is now equal to quantity, stop cart ajax button')
          addToCartButton.setAttribute("disabled", "");
          addToCartButton.classList.add("disabled--button");
          addToCartButton.querySelector(".disabled-text").textContent =
            "Sold Out";
        } else {
          // // console.log('max is not equal to quantity, enable cart ajax button')
          addToCartButton.removeAttribute("disabled");
          addToCartButton.classList.remove("disabled--button");
        }
      }
    }
  },
  qtyCartCheck: function() {
    if (productCheck) {
      // console.log("product check");
      fetch("/cart")
      .then(function (response) {
        return response.text();
      })
      .then(function (html) {
        // console.log("fetch and check cart")
        let parser = new DOMParser(),
            htmlCart = parser.parseFromString(html, "text/html"),
            dataCartContents = htmlCart.querySelector(".main-cart-contents"),
            selectedVariantId = addToCartForm.querySelector(".js-variant-id").value
            lineItemCheck(dataCartContents, selectedVariantId)
            // dataLineItems.forEach((item) => {
            //   qtyInCart(item);
            // });
      })
      .catch((error) => {
        console.error("Error:", error), ajaxify.onError;
      });
    
    }
  }, 
  init: function () {
    let removeLines = document.querySelectorAll(removeLineSelector),
      lineQuantities = document.querySelectorAll(lineQuantitySelector);

    lineItem.qtyCartCheck()
    
    removeLines.forEach((line) => {
      line.addEventListener("click", lineItem.onLineRemoved);
    });

    lineQuantities.forEach((qty) => {
      qty.addEventListener("change", lineItem.onLineQtyChanged);
    });
  },
};

function reinitQuantityInput() {
  // Find all quantity-input elements
  const quantityInputs = document.querySelectorAll("quantity-input");

  // Loop through each quantity-input element and reapply the logic
  quantityInputs.forEach((quantityInput) => {
    if (!quantityInput.initialized) {
      // Mark the element as initialized to prevent duplicate event listeners
      quantityInput.initialized = true;

      const input = quantityInput.querySelector("input");
      const buttons = quantityInput.querySelectorAll("button");

      buttons.forEach((button) => {
        button.addEventListener("click", function (event) {
          event.preventDefault();

          const previousValue = parseInt(input.value);
          const max = parseInt(input.getAttribute("max"));
          const min = parseInt(input.getAttribute("min"));
          const thisName = button.getAttribute("name");

          if (thisName === "plus") {
            input.stepUp();
          } else if (thisName === "minus") {
            input.stepDown();
          }

          // Update button states
          if (input.value == max) {
            quantityInput.querySelector("button[name=plus]").setAttribute("disabled", "");
          } else {
            quantityInput.querySelector("button[name=plus]").removeAttribute("disabled");
          }

          if (input.value == min) {
            quantityInput.querySelector("button[name=minus]").setAttribute("disabled", "");
          } else {
            quantityInput.querySelector("button[name=minus]").removeAttribute("disabled");
          }

          // Dispatch a change event if the value has changed
          if (previousValue != input.value) {
            input.dispatchEvent(new Event("change"));
            input.setAttribute("value", input.value);
          }
        });
      });
    }
  });
}

function cartScripts() {
  reinitQuantityInput();
  productForm.init();
  ajaxify.init();
  lineItem.init();
  console.log("init cart scripts");
}

cartScripts();

document.addEventListener("recommendationsLoaded", () => {
  cartScripts();
});